import {Skeleton} from '@kaman/uikit';

const BranchesListSkeleton = () => {
    const skeletonCard = (index: number) => (
        <div
            key={index}
            style={{
                width: '100%',
                minWidth: '300px',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                padding: '8px',
                paddingBottom: '12px',
                borderBottom: index < 4 ? '1px solid #E5E7EB' : undefined,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                }}
            >
                <div
                    style={{display: 'flex', alignItems: 'center', gap: '8px'}}
                >
                    <Skeleton variant="circular" width={36} height={36} />
                    <Skeleton width="40%" height={20} />
                </div>
                <Skeleton width="25%" height={20} />
            </div>

            <div style={{paddingRight: '48px'}}>
                <Skeleton width="100%" height={16} />
                <div style={{marginTop: '4px'}}>
                    <Skeleton width="85%" height={16} />
                </div>
            </div>
        </div>
    );

    return (
        <div aria-busy="true" aria-label="در حال بارگذاری لیست شعب">
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Skeleton width="30%" height={24} />
                <Skeleton width={96} height={32} />
            </div>

            <div
                style={{
                    marginTop: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {[0, 1, 2, 3, 4].map((i) => skeletonCard(i))}
            </div>
        </div>
    );
};

export default BranchesListSkeleton;
